import createRecipientWell from 'owa-readwrite-recipient-well/lib/utils/createRecipientWell';
/**
 * Maps people identity objects on an inbox rule to the edit page's recipient well view state, to prepopulate personas
 * @return the RecipientWellWithFindControlViewState populated with the PeopleIdentities as personas
 */
export default function mapPeopleIdentityToRecipientWellWithFindControlViewState(peopleIdentity) {
    // map conditional clauses
    var initialMailboxes = [];
    for (var _i = 0, peopleIdentity_1 = peopleIdentity; _i < peopleIdentity_1.length; _i++) {
        var identity = peopleIdentity_1[_i];
        var mailbox = {
            Name: identity.DisplayName,
            EmailAddress: identity.SmtpAddress,
            RoutingType: identity.RoutingType,
        };
        initialMailboxes.push(mailbox);
    }
    return createRecipientWell(null, initialMailboxes);
}
//# sourceMappingURL=mapPeopleIdentityToReadWriteRecipientWellViewState.js.map